// extracted by mini-css-extract-plugin
module.exports = {"staggeredImagesContainer":"simple-staggered-bloc-list-component_staggeredImagesContainer__3I-ft"};